export const initializeAccordion = (containerSelector, itemSelector, titleSelector, contentSelector) => {
  const containers = [...document.querySelectorAll(containerSelector)];

  containers.forEach((container) => {
    const accordionItems = [...container.querySelectorAll(itemSelector)];

    accordionItems.forEach((accordionItem) => {
      const title = accordionItem.querySelector(titleSelector);
      const content = accordionItem.querySelector(contentSelector);

      if (content) {
        title.addEventListener("click", (e) => {
        
          if (!container.classList.contains("filter__main")) {
            accordionItems.forEach((item) => {
              if (item !== accordionItem) {
                item.classList.remove("opened");
              }
            });
          };

          if (!accordionItem.classList.contains("opened")) {
            e.preventDefault();
          };

          accordionItem.classList.toggle("opened");
        });
      }
    });
  });
};

